<template>
  <span>
      {{text}}
  </span>
</template>

<script>
import { mapState } from 'vuex'
import Polyglot from 'node-polyglot'
import languages from '../locales'

export default {
  name: 'Translate',
  props: ['directive', 'dynamicContent'],
  data () {
    return {
      text: ''
    }
  },
  computed: {
    ...mapState(['locale'])
  },
  created () {
    let polyglot
    if (languages[this.locale]) {
      // We support this language. Go ahead
      polyglot = new Polyglot({ phrases: languages[this.locale], locale: this.locale })
    } else {
      // Default to english
      polyglot = new Polyglot({ phrases: languages.en, locale: 'en' })
    }

    this.text = polyglot.t(this.directive, this.dynamicContent)
  }
}
</script>

<style scoped lang="scss">

</style>
